<template>
    <div class="app" style="height: 100%; padding: 10px;">
        <div class="title">
            <van-cell is-link @click="showPopup" title="公共区域" />
        </div>
        <div class="tenantArea">
            <div style="border-bottom: 1px solid #E7E5E7;">
                <van-cell is-link title="租户区域" />
            </div>
            <div style=" margin-top: 10px;">
                <EqSearch placeholder="输入地址/租户名称/品牌名称进行搜索" class="choice-tenant-search" v-model="searchValue">
                </EqSearch>
                <EqButton name="搜索" class="choice-tenant-button" @click.native="choiceSelect"></EqButton>
            </div>
            <template>
                <div class="content">
                    <vue-tree-list @click="onClick" @change-name="onChangeName" @delete-node="onDel"
                        @add-node="onAddNode" :model="getTree" default-tree-node-name="new node"
                        default-leaf-node-name="new leaf" v-bind:default-expanded="false" :delNodeDisabled="true">
                        <!-- <template v-slot:leafNameDisplay="slotProps">
                            <span>
                                {{ slotProps.model.name }} <span class="muted">#{{ slotProps.model.id }}</span>
                            </span>
                        </template> -->
                        <!-- <span class="icon" slot="addTreeNodeIcon">📂</span>
                        <span class="icon" slot="addLeafNodeIcon">＋</span>
                        <span class="icon" slot="editNodeIcon">📃</span>
                        <span class="icon" slot="delNodeIcon">✂️</span>
                        <span class="icon" slot="leafNodeIcon">🍃</span>
                        <span class="icon" slot="treeNodeIcon">🌲</span> -->
                    </vue-tree-list>
                </div>
                <div v-if="defaultText || noResultText" style="text-align: center; margin-top: 20px;">
                    <van-image width="150" height="150" :src="defaultLogo" />
                </div>
                <div style="text-align: center;margin-top: 20px; margin-bottom: 20px;">
                    <span v-if="defaultText">请输入搜索条件查找租户区域施工位置</span>
                    <br />
                    <span v-if="noResultText">未找到施工位置，请重新输入正确的搜索内容</span>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import EqSearch from "@/components/Commons/EqSearch";
import EqButton from "@/components/Commons/EqButton";
import defaultPicture from "@/assets/myElectronicPass/defaultPicture.png";
import { Cell, Image } from "vant";
import { client } from "@/libraries/http";
import { VueTreeList, Tree } from 'vue-tree-list';
import eventBus from '@/router/eventBus';

// const filteChildren = (items, filters) => {
//     return items.filter(item => {
//         if (item.name.includes(filters)) {
//             return item.children;
//         } else {
//             return filteChildren(item.children, filters);
//         }
//     });
// }

const rebuildEntityTree = (value, arr) => {
    if (!arr) {
        return []
    }
    let newarr = [];
    arr.forEach(element => {
        if (element.name.indexOf(value) > -1) {
            const ab = rebuildEntityTree(value, element.children);
            const obj = {
                ...element,
                children: ab
            }
            newarr.push(obj);
        } else {
            if (element.children && element.children.length > 0) {
                const ab = rebuildEntityTree(value, element.children);
                const obj = {
                    ...element,
                    children: ab
                };
                if (ab && ab.length > 0) {
                    newarr.push(obj);
                }
            }
        }
    });
    return newarr;
};

export default {
    name: "constructionLocation",
    components: {
        EqSearch, EqButton, "van-cell": Cell, "van-image": Image, "vue-tree-list": VueTreeList,
    },
    props: {

    },
    data() {
        return {
            searchValue: undefined,
            defaultLogo: defaultPicture,
            defaultText: true,
            noResultText: false,
            newTree: {},
            dataValue: [],
        };
    },
    created() {

    },
    computed: {
        getTree() {
            return new Tree(this.dataValue);
        }
    },
    methods: {
        choiceSelect() {
            console.log("aaaaa")
            client.post("/api/work-order-engine-tenant", { projectId: "13424187677" }).then((res) => {
                const spatialInformation = res.data.children.filter(area => area.name === '租户区域');
                // this.dataValue = spatialInformation[0].children;
                const spatialInformationValue = spatialInformation[0].children;
                console.log(spatialInformationValue)
                // this.dataValue = spatialInformationValue.filter(aaa => aaa.name.includes(this.searchValue))
                // this.dataValue = spatialInformationValue.filter(oneLevel => oneLevel.children.filter(secondLevel => secondLevel.children.filter(threeLevel => threeLevel.name.includes(this.searchValue))))
                this.dataValue = rebuildEntityTree(this.searchValue, spatialInformationValue)
                console.log(this.dataValue);
                this.defaultText = false;
                this.noResultText = false;
            });
        },
        choiceTenant() {
            console.log("aaaaa");
            this.$router.go(-1)
        },
        showPopup() {
            eventBus.$emit('CONSTRUCTION_LOCATION','公共区域');
            this.$router.go(-1)
        },
        onDel(node) {
            console.log(node)
            // node.remove()
        },



        onChangeName(params) {
            console.log(params)
            console.log("onChangeName")
        },

        onAddNode(params) {
            console.log(params)
        },

        onClick(params) {
            console.log(params)
            console.log("onClick")
        },

        addNode() {
            // var node = new TreeNode({ name: 'new node', isLeaf: false })
            // if (!this.data.children) this.data.children = []
            // this.data.addChildren(node)
        },

        getNewTree() {
            var vm = this
            function _dfs(oldNode) {
                var newNode = {}

                for (var k in oldNode) {
                    if (k !== 'children' && k !== 'parent') {
                        newNode[k] = oldNode[k]
                    }
                }
                if (oldNode.children && oldNode.children.length > 0) {
                    newNode.children = []
                    for (var i = 0, len = oldNode.children.length; i < len; i++) {
                        newNode.children.push(_dfs(oldNode.children[i]))
                    }
                }
                return newNode
            }

            vm.newTree = _dfs(vm.data)
        },
    },
};
</script>
<style scoped>
.content {
    /* border: 1px solid #E7E5E7;
    border-radius: 5px; */
    margin: 10px 12px 0px 12px;
}

.tenantArea {
    border: 1px solid #E7E5E7;
    border-radius: 5px;
    margin-top: 10px;
}

.choice-list {
    width: 353px;
    border: 1px solid #E7E5E7;
    border-radius: 5px;
    margin-left: 25px;
    margin-top: 20px;
}

.title {
    border: 1px solid #E7E5E7;
    border-radius: 5px;
}

.choice-tenant-button {
    width: 70px;
    height: 36px;
    float: right;
    margin-top: -40px;
    margin-right: 40px;
}

.choice-tenant-search>>>.van-icon-search:before {
    content: '';
}

.choice-tenant-search {
    width: 275px;
    height: 44px;
    /* float: left; */
}

.choice-tenant-search>>>.van-search__content {
    border: 1px solid #E7E5E7;
    background-color: white;
    padding-left: 0px;
}
</style>
  